var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2458_7367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.333 1.33203H2.66634C1.93301 1.33203 1.33967 1.93203 1.33967 2.66536L1.33301 14.6654L3.99967 11.9987H13.333C14.0663 11.9987 14.6663 11.3987 14.6663 10.6654V2.66536C14.6663 1.93203 14.0663 1.33203 13.333 1.33203ZM4.66634 5.9987H11.333C11.6997 5.9987 11.9997 6.2987 11.9997 6.66536C11.9997 7.03203 11.6997 7.33203 11.333 7.33203H4.66634C4.29967 7.33203 3.99967 7.03203 3.99967 6.66536C3.99967 6.2987 4.29967 5.9987 4.66634 5.9987ZM8.66634 9.33203H4.66634C4.29967 9.33203 3.99967 9.03203 3.99967 8.66536C3.99967 8.2987 4.29967 7.9987 4.66634 7.9987H8.66634C9.03301 7.9987 9.33301 8.2987 9.33301 8.66536C9.33301 9.03203 9.03301 9.33203 8.66634 9.33203ZM11.333 5.33203H4.66634C4.29967 5.33203 3.99967 5.03203 3.99967 4.66536C3.99967 4.2987 4.29967 3.9987 4.66634 3.9987H11.333C11.6997 3.9987 11.9997 4.2987 11.9997 4.66536C11.9997 5.03203 11.6997 5.33203 11.333 5.33203Z",
    fill: "#29C0BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2458_7367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.55f82de3bb155c2bbe718c360d896938.svg";
export { ForwardRef as ReactComponent };